import * as React from "react";

import JobCreate from "./../../components/Job/JobCreate";

const JobCreatePage: React.FC = () => <JobCreate />;

export default JobCreatePage;
